import { Box, Flex } from 'reflexbox/styled-components';
import styled, { css } from 'styled-components';

import { shadowHard, shadowSoft } from '../../../../previewUI/styles/global.js';
import Slider from '../Slider/index.js';

export const AddedTitle = styled(Box)`
  max-height: 38px;
  line-height: 38px;
  overflow: hidden;
  cursor: pointer;
  display: ${(props) => (props.layout === 5 || props.layout === 4 ? 'block' : 'none')};
  width: 100%;
  padding: 0 10px;
  margin-top: ${(props) => (props.layout === 5 ? '-30px' : '-13px')};
  text-align: center;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  box-shadow: rgba(0, 0, 0, 0.3) 0 10px 30px 0;

  @media (min-width: 798px) {
    margin-bottom: ${(props) => (props.layout === 5 ? '30px' : '25px')};
  }

  @media (max-width: 797px) {
    margin-top: -25px;
    margin-bottom: 25px;
  }

  ${(props) =>
    props.background &&
    css`
      background: ${props.background};
    `}

  ${(props) =>
    props.textColor &&
    css`
      color: ${props.textColor};
    `}

  ${(props) =>
    props.isInsideDashboard &&
    css`
      margin-top: -25px;
      margin-bottom: 25px;
    `}
`;

export const PhotoImg = styled.img`
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;

  ${({ layout }) =>
    layout === 4 &&
    css`
      border-top-left-radius: 6px;
      border-top-right-radius: 6px;

      ${(props) =>
        props.postLayout === 0 &&
        css`
          border-bottom-left-radius: 6px;
          border-bottom-right-radius: 6px;
        `}

      ${(props) =>
        props.shadow &&
        css`
          border-top-left-radius: 3px;
          border-top-right-radius: 3px;
        `}
    `}

  ${(props) =>
    props.isGallery &&
    css`
      width: 100%;
    `}

  ${(props) =>
    props.layout === 2 &&
    css`
      aspect-ratio: 1;
    `}

  ${(props) =>
    props.layout === 5 &&
    css`
      max-height: 300px;
      object-position: 20% 20%;
    `}
  
  ${(props) =>
    props.layout === 6 &&
    css`
      display: flex;
      float: left;
    `}
  ${(props) =>
    props.layout === 6 &&
    props.postLayout === 0 &&
    css`
      max-width: 100%;
      object-position: 50% 50%;
    `}

  ${(props) =>
    props.layout === 7 &&
    css`
      border-top-left-radius: 3px;
      border-top-right-radius: 3px;
    `}

  ${(props) =>
    props.shape === 'square' &&
    css`
      border-radius: 6px !important;

      &:hover {
        border-radius: 6px !important;
      }
    `}

  ${(props) =>
    props.shape === 'round' &&
    css`
      border-radius: 32px !important;

      &:hover {
        border-radius: 32px !important;
      }
    `}
`;

export const BuyButton = styled(Box)`
  min-width: 60px;
  text-align: center;
  padding: 5px 10px;
  background-color: transparent;
  position: absolute;
  bottom: 10px;
  right: 10px;
  z-index: 1;
  color: black;
  border-radius: 12px;
  font-size: 13px;

  ${(props) =>
    !props.isHide &&
    css`
      display: none;
    `}

  ${(props) =>
    props.linked &&
    css`
      display: flex;
      justify-content: center;
      align-items: center;
      min-width: 0;
      padding: 6px;
    `}

  ${(props) =>
    props.insidePost &&
    css`
      padding: 10px 6px 6px;
    `}

  ${(props) =>
    props.insidePostLayout &&
    css`
      top: -5px;
      right: 0;
      left: auto;
      bottom: auto;
      color: #b2b2b2;
    `}
`;

export const AddToBasketIconLink = styled(Box)`
  width: 30px;
  height: 30px;
`;

export const ShadowBox = styled(Box)`
  ${(props) =>
    props.shadow === 'soft' &&
    css`
      ${shadowSoft};
    `}
  ${(props) =>
    props.shadow === 'hard' &&
    css`
      ${shadowHard};
      outline: none;
    `}
`;

export const PhotoBox = styled(Box)`
  cursor: pointer;
  position: relative;
  width: 100%;
  margin-bottom: 16px;
  border-radius: 6px;
  overflow: hidden;

  ${(props) =>
    props.layout === 1 &&
    css`
      display: flex;
      width: 98%;
      aspect-ratio: 1 / 1;
      overflow: hidden;
      user-select: none;
      border-radius: 6px;
      margin-bottom: 10px;

      ${(props) =>
        props.third &&
        css`
          margin-right: 0;
        `}
    `}

  ${(props) =>
    props.layout === 3 &&
    css`
      display: block;

      overflow: hidden;
      user-select: none;

      border-radius: 6px;
      max-height: 250px;
      width: calc(33.3% - 8px);

      margin-right: 4px;
      margin-left: 4px;
      margin-bottom: 16px;

      ${(props) =>
        props.third &&
        css`
          margin-right: 0;
        `}
    `}

  
  
  ${(props) =>
    props.layout === 4 &&
    css`
      display: flex;
      flex-direction: column;
      align-items: center;

      overflow: visible;
      border-radius: 6px;
      margin-right: 0;

      @media (min-width: 798px) {
        margin-bottom: 13px;
      }

      @media (max-width: 797px) {
        margin-bottom: 25px;
      }

      ${(props) =>
        props.isInsideDashboard &&
        css`
          margin-bottom: 25px;
        `}
    `}


  
  ${(props) =>
    props.layout === 5 &&
    css`
      display: flex;
      align-items: center;

      overflow: hidden;
      height: 6em;
      border-radius: 5px;

      @media (min-width: 798px) {
        margin-bottom: 30px;
        height: 15em;

        ${(props) =>
          props.third &&
          css`
            margin-right: 0;
          `}

        ${(props) =>
          !props.isTitle &&
          css`
            height: calc(6em + 38px);
          `}
      }

      @media (max-width: 797px) {
        margin-bottom: 25px;

        ${(props) =>
          !props.isTitle &&
          css`
            height: calc(6em + 38px);
          `}
      }

      ${(props) =>
        props.isInstantRedirect &&
        css`
          border-bottom-left-radius: 0;
          border-bottom-right-radius: 0;
        `}

      ${(props) =>
        props.isInsideDashboard &&
        css`
          margin-bottom: 25px;

          ${(props) =>
            !props.isTitle &&
            css`
              height: calc(6em + 38px);
            `}
        `}
    `}



  ${(props) =>
    props.layout === 6 &&
    css`
      display: flex;

      overflow: hidden;
      color: #000;
      height: 8em;
      background: ${props.postBackgroundColor ? props.postBackgroundColor : '#ffffff'};

      border-radius: 6px;
      border: ${props.btnBackgroundColor === '#ffffff' && props.backgroundColor === '#ffffff' ? '1px solid #dadce0' : 'none'};

      @media (min-width: 798px) {
        height: 8em;

        ${(props) =>
          props.third &&
          css`
            margin-right: 0;
          `}
      }
    `}
  
    ${(props) =>
    props.isBlog &&
    props.layout === 6 &&
    css`
      width: 100%;
    `}

  ${(props) =>
    props.layout === 9 &&
    css`
      display: flex;

      overflow: hidden;
      color: #000;
      background: ${props.postBackgroundColor ? props.postBackgroundColor : '#ffffff'};
      width: 100%;

      border-radius: 6px;
      border: ${props.btnBackgroundColor === '#ffffff' && props.backgroundColor === '#ffffff' ? '1px solid #dadce0' : 'none'};
    `}
  
    ${(props) =>
    props.shape === 'square' &&
    css`
      border-radius: 8px !important;

      &:hover {
        border-radius: 8px !important;
      }
    `}
  
    ${(props) =>
    props.shape === 'round' &&
    css`
      border-radius: 34px !important;

      &:hover {
        border-radius: 34px !important;
      }
    `}

  ${(props) =>
    props.border === 'solid' &&
    css`
      border: 2px solid ${props.borderColor} !important;

      &:hover {
        border: 2px solid ${props.borderColor} !important;
      }
    `}

  ${(props) =>
    props.border === 'none' &&
    css`
      border: none !important;
      outline: none !important;
    `}

    ${(props) =>
    props.shadow === 'hard' &&
    css`
      box-shadow: ${props.shadowColor} 8px 8px 0 0;
    `}
    
    ${(props) =>
    props.shadow === 'soft' &&
    css`
      ${shadowSoft};
    `}

    ${(props) =>
    props.shadow === 'hard' &&
    props.border === 'double' &&
    css`
      box-shadow:
        ${props.shadowColor} 8px 8px 0 0,
        ${props.borderColor} 8px 8px 0 2px;
      border: 2px solid ${props.borderColor} !important;
    `}

  ${(props) =>
    props.opacity &&
    css`
      opacity: ${props.opacity};
    `}

  ${(props) =>
    props.overflow &&
    css`
      overflow: ${props.overflow};
    `}
  ${(props) =>
    props.isBorder &&
    css`
      border: 1px solid rgb(224, 226, 233);
    `}
  ${(props) =>
    props.width &&
    css`
      width: ${props.width};
    `}
  ${(props) =>
    props.relative &&
    css`
      position: relative;
    `}
`;

export const PhotoList = styled(Flex)`
  margin-top: 21px;
  flex-wrap: wrap;
  margin-bottom: 40px;

  @media (max-width: 797px) {
    margin-bottom: 12px;
  }

  ${(props) =>
    (props.layout === 1 || props.layout === 3) &&
    css`
      margin-top: 10px;
    `}

  ${(props) =>
    (props.layout === 2 || props.layout === 8) &&
    css`
      margin: 10px 0 40px;
      width: 100%;
      justify-content: space-between;

      @media (max-width: 797px) {
        margin: 15px 0;
      }

      ${(props) =>
        props.isInsideDashboard &&
        css`
          margin: 15px 0;
        `}
    `}

  
  
  ${(props) =>
    (props.layout === 3 || props.layout === 5) &&
    css`
      ${(props) =>
        props.background &&
        css`
          background: ${props.background};
        `}

      ${(props) =>
        props.textColor &&
        css`
          color: ${props.textColor};
        `}
    `}
  
  
  
  ${(props) =>
    (props.layout === 4 || props.layout === 5 || props.layout === 6) &&
    css`
      margin-top: 25px;
      margin-bottom: 12px;

      @media (max-width: 797px) {
        margin-bottom: 12px;
      }

      ${(props) =>
        props.isInsideDashboard &&
        css`
          margin-bottom: 12px;
        `}
    `}
  
  
  
  ${(props) =>
    props.layout === 7 &&
    css`
      margin: 10px 0 40px;
      width: 100%;
      justify-content: space-between;

      @media (max-width: 797px) {
        margin: 15px 0;
      }

      ${(props) =>
        props.isInsideDashboard &&
        css`
          margin: 15px 0;
        `}
    `}
`;

export const AddedMark = styled(Box)`
  min-width: 60px;
  text-align: center;
  padding: 5px 10px;
  background-color: white;
  position: absolute;
  bottom: 10px;
  right: 10px;
  color: black;
  border-radius: 12px;
  font-size: 13px;

  ${PhotoBox}:hover & {
    display: none;
  }

  ${(props) =>
    !props.isHide &&
    css`
      display: none;
    `}

  ${(props) =>
    props.linked &&
    css`
      display: flex;
      justify-content: center;
      align-items: center;
      min-width: 0;
      padding: 6px;
    `}
  
  ${(props) =>
    props.displayLinkIcon &&
    css`
      display: none;
    `}
`;

export const Wrap = styled(Box)`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: start;
  padding: 8px 16px;
  ${(props) =>
    props.spaceAround &&
    css`
      justify-content: space-around;
    `}
`;

export const TextTitle = styled(Box)`
  width: 100%;
  background: #ffffff;

  ${(props) =>
    props.background &&
    css`
      background: ${props.background};
    `}

  ${(props) =>
    props.textColor &&
    css`
      color: ${props.textColor};
    `}
  
  ${({ layout }) =>
    layout === 6 &&
    css`
      overflow: hidden;
      text-overflow: ellipsis;
      max-height: 46px;
    `}

  ${({ layout, isButton }) =>
    layout === 6 &&
    isButton &&
    css`
      max-height: 46px;
    `}

  ${({ layout }) =>
    (layout === 1 || layout === 3 || layout === 5) &&
    css`
      display: none;
    `}
  
  ${({ layout }) =>
    (layout === 2 || layout === 7 || layout === 8) &&
    css`
      padding: 0 10px 10px;
      margin-top: -5px;
      min-height: 32px;
      font-size: 14px;
    `}

  ${({ layout }) =>
    (layout === 2 || layout === 4 || layout === 7 || layout === 8) &&
    css`
      border-bottom-left-radius: 6px;
      border-bottom-right-radius: 6px;

      ${(props) =>
        props.background &&
        css`
          background: ${props.background};
        `}

      ${(props) =>
        props.shadow &&
        css`
          border-bottom-left-radius: 3px;
          border-bottom-right-radius: 3px;
        `}
    `}


  
  
  ${(props) =>
    props.layout === 4 &&
    css`
      padding: 10px 15px;
    `}
  
  ${(props) =>
    props.layout === 6 &&
    css`
      max-width: 100%;
      font-weight: bold;
      overflow: hidden;
      box-shadow: none;

      ${(props) => props.isInsideDashboard && css``}
    `}
  
  ${(props) =>
    !props.isPostShadow &&
    css`
      box-shadow: none;
    `}

  ${(props) =>
    props.isViewPost &&
    css`
      box-shadow: 1px 2px 10px rgb(0 0 0 / 8%);
    `}
  ${(props) =>
    props.padding &&
    css`
      padding: ${props.padding};
    `}
`;

export const EmptyBlock = styled(Box)`
  width: 100%;

  ${(props) =>
    props.layout === 1 &&
    css`
      width: 100%;
      height: 100%;
    `}

  ${(props) =>
    props.layout === 6 &&
    css`
      width: 100%;
      overflow: hidden;
    `}

  ${(props) =>
    props.layout === 7 &&
    css`
      height: 100%;
    `}
  ${(props) =>
    props.layout === 9 &&
    css`
      padding: 8px;
      width: 100%;
      height: 100%;
    `}
`;

export const SliderWrap = styled(Slider)`
  .swiper-wrapper {
    padding: 20px !important;
    margin-left: -20px !important;
  }

  ${(props) =>
    props.isViewPost &&
    css`
      padding: 20px !important;
      margin-left: -20px !important;
    `}
`;
